module.exports = __webpack_public_path__ + "static/media/image-marquee.46bbd603.jpg";